import { connect } from 'react-redux'
import { selectIntegrationSettingsByProvider } from 'ducks/integrations'
import { selectCurrentUser } from 'ducks/currentUser/selectors'
import { selectIsMailboxIndicatorNeeded } from 'selectors/currentChangesets'
import {
  selectCurrentTicketId,
  selectCurrentTicketMailboxName,
  selectCurrentTicketMailboxColor,
} from 'selectors/tickets'
import { doShowSnackbar } from 'actions/snackbar'

import ExpandedMessageView from './view'

const select = state => {
  const mailboxIndicatorNeeded = selectIsMailboxIndicatorNeeded(state)
  return {
    currentUserId: selectCurrentUser(state).id,
    ticketId: selectCurrentTicketId(state),
    mailboxIndicatorNeeded,
    mailboxName:
      mailboxIndicatorNeeded && selectCurrentTicketMailboxName(state),
    mailboxColor:
      mailboxIndicatorNeeded && selectCurrentTicketMailboxColor(state),
    integrationSettings: selectIntegrationSettingsByProvider(state),
  }
}

const perform = {
  doShowSnackbar,
}

export default connect(select, perform)(ExpandedMessageView)
